import { Box, styled } from "components/common";

export const ProductDetailsRecommendationsWrapper = styled(Box)(
  ({ theme }) => ({
    padding: theme.spacing(3),

    [theme.breakpoints.down("md")]: {
      padding: theme.spacing(2),
    },
    "& .custom-product-swiper": {
      width: "100%",
      maxWidth: 1200,
      // overflow: "visible",
      "& .swiper-button-next, .swiper-button-prev": {
        //   "--swiper-navigation-sides-offset": "0px",
        width: 48,
        height: 48,
        backgroundColor: "#D9D9D9",
        borderRadius: 10,
        [theme.breakpoints.down("md")]: {
          width: 35,
          height: 35,
          "--swiper-navigation-sides-offset": "0",
          "&:after": {
            "--swiper-navigation-size": 15,
          },
        },

        "&:after": {
          "--swiper-navigation-size": 20,
          fontWeight: "bold",
          color: "black",
        },
      },
    },
  })
);
